/* eslint-disable import/prefer-default-export */
/* eslint-disable func-names */
import { callApiServiceCommon } from './service-common';

const blogApi = 'https://blog.autoketing.com/autoketingblog-posts';
const upSellApi = process.env.REACT_APP_UPSELL_API;
const commonApi = process.env.REACT_APP_API_COMMON_SERVICE;

export function* getListBlogServer(number) {
  const payload = {
    method: 'GET',
    url: `${blogApi}`,
    params: {
      'post-per-page': number
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* getShopInfoService(shop_domain) {
  const payload = {
    method: 'GET',
    url: `${commonApi}ak/get-shop-info`,
    params: {
      shop_domain,
      app_code: 'ups'
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* getCurrencyShopService() {
  const payload = {
    method: 'GET',
    url: `${upSellApi}upsell/get-shop-currency`,
    params: {}
  };
  return yield callApiServiceCommon(payload);
}

export function* getListUpsellCampaignService(type) {
  const payload = {
    method: 'GET',
    url: `${upSellApi}ups-v2/get-list-settings`,
    params: {
      upsell_type: type
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* getDetailCampaignUpsellService(id) {
  const payload = {
    method: 'GET',
    url: `${upSellApi}ups-v2/get-detail`,
    params: {
      id
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* getProductsDetailService(ids) {
  const payload = {
    method: 'GET',
    url: `${upSellApi}upsell/get-list-product-detail-new`,
    params: {
      productId: JSON.stringify(ids)
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* getCollectionDetailService(ids) {
  const payload = {
    method: 'GET',
    url: `${upSellApi}ups/get-collections-new`,
    params: {
      collection_id: JSON.stringify(ids)
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* saveSettingUpSellCampaignService(campaign) {
  const upsellType = campaign.get('upsellType');
  // target
  const targetType = campaign.get('targetType');
  const targetProductIds = campaign.get('targetProductIds');
  const targetCollectionIds = campaign.get('targetCollectionIds');
  const targetIds = targetType === 'products' ? targetProductIds : targetCollectionIds;
  // recommend
  const recommendType = campaign.get('recommendType');
  const recommendProductIds = campaign.get('recommendProductIds');
  const recommendCollectionIds = campaign.get('recommendCollectionIds');
  const recommendIds = recommendType === 'products' ? recommendProductIds : recommendCollectionIds;
  // discount
  const dcTargetProducts = campaign.get('dcTargetProducts');
  const dcTargetCollection = campaign.get('dcTargetCollection');
  const dcRecommendProducts = campaign.get('dcRecommendProducts');
  const dcRecommendCollection = campaign.get('dcRecommendCollection');
  const dcTarget = targetType === 'products' ? dcTargetProducts : dcTargetCollection;
  const dcRecommend = recommendType === 'products' ? dcRecommendProducts : dcRecommendCollection;
  const discountType = campaign.get('discountType');
  const offerMessage = campaign.get('offerMessage');
  const motivationalMessage = campaign.get('motivationalMessage');
  const message = discountType === 'no' ? offerMessage : motivationalMessage;
  // recommend
  const payload = {
    method: 'POST',
    url: `${upSellApi}ups-v2/save-settings`,
    params: {
      id: campaign.get('id'),
      campaignName: campaign.get('campaignName'),
      upsellType: campaign.get('upsellType'), // 'popup', 'bundle'
      showProductPage: true,
      showCartPage: false,
      targetType,
      targetIds: JSON.stringify(targetIds),

      recommendType,
      recommendIds: JSON.stringify(upsellType === 'bundle' ? targetProductIds : recommendIds),
      bundleMessage: message,
      bundleSuccessMessage: campaign.get('congratulatoryMessage') || '',
      discountType,
      discountValue: campaign.get('discountValue') || 0,
      dcTarget: JSON.stringify(dcTarget),
      dcRecommend: JSON.stringify(dcRecommend),
      showOnDesktop: campaign.get('showOnDesktop'),
      showOnMobile: campaign.get('showOnMobile'),
      startDate: campaign.get('startDate'),
      activeEndDate: campaign.get('activeEndDate'),
      endDate: campaign.get('endDate')
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* changeStatusCampaignUpsellService(actions) {
  const id = actions.payload.id;
  const status = actions.payload.status;
  const payload = {
    method: 'POST',
    url: `${upSellApi}ups-v2/active-setting`,
    params: {
      ids: JSON.stringify([id]),
      status
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* deleteCampaignUpsellV2Service(actions) {
  const payload = {
    method: 'POST',
    url: `${upSellApi}ups-v2/delete-setting`,
    params: {
      ids: JSON.stringify([actions.id])
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* getDataSettingDesignService() {
  const payload = {
    method: 'GET',
    url: `${upSellApi}upsell/global-extra-settings`,
    params: {}
  };
  return yield callApiServiceCommon(payload);
}

export function* saveSettingDesignService(data) {
  const design = {
    upsellPopup: data.get('upsellPopup'),
    upsellBundle: data.get('upsellBundle'),
    otherSettings: data.get('otherSettings'),
    version: 2
  };
  const payload = {
    method: 'POST',
    url: `${upSellApi}upsell/global-extra-settings`,
    params: {
      global_extra_settings: JSON.stringify(design)
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* getPricingPlanService() {
  const payload = {
    method: 'GET',
    url: `${upSellApi}ups-v2/get-current-plan`,
    params: {}
  };
  return yield callApiServiceCommon(payload);
}

export function* upgradePlanService({ price_name, year_charge, apply_sales_event }) {
  const payload = {
    method: 'POST',
    url: `${upSellApi}ups-v2/register-charge`,
    params: {
      price_name,
      year_charge,
      apply_sales_event
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* getCountViewService() {
  const payload = {
    method: 'GET',
    url: `${upSellApi}ups-v2/get-views-count`,
    params: {}
  };
  return yield callApiServiceCommon(payload);
}

export function* getViewByPlanService() {
  const payload = {
    method: 'GET',
    url: `${upSellApi}ups-v2/get-views-by-plan-date`,
    params: {}
  };
  return yield callApiServiceCommon(payload);
}

export function* getStatisticChartService(data) {
  const payload = {
    method: 'GET',
    url: `${upSellApi}ups-v2/get-statistic-chart`,
    params: {
      start_date: data.startDate,
      end_date: data.endDate
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* changeAppStatusService(status) {
  const payload = {
    method: 'POST',
    url: `${upSellApi}ups-v2/on-off-app`,
    params: {
      status_app: status
    }
  };
  return yield callApiServiceCommon(payload);
}
